import PropTypes from 'prop-types'

export default function ItemDisplay({children}) {
  return <dt className="list__title--product-warehouse">{children}</dt>
}

ItemDisplay.propTypes = {
  children: PropTypes.node,
}
